// extracted by mini-css-extract-plugin
module.exports = {"container":"IframeVideo_container__tuURq","iframe-container":"IframeVideo_iframe-container__kKkJL"};